import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=368446ba&scoped=true&"
import script from "./Block.vue?vue&type=script&lang=ts&"
export * from "./Block.vue?vue&type=script&lang=ts&"
import style0 from "./Block.vue?vue&type=style&index=0&id=368446ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368446ba",
  null
  
)

export default component.exports